module.exports = __webpack_public_path__ + "assets/f85978507378833696b613c40326543c.svg";